import { AsyncUsageInfo } from "@app/shared";
import { HardwareStatusChart, HardwareStatusChartProps, SeriesDetails } from "./HardwareStatusChart";
import { TooltipItem } from "chart.js";
import { ChartProps } from "react-chartjs-2";
import { deepMerge } from "../../../helpers";

type AsyncMetricsChartProps = Omit<HardwareStatusChartProps<AsyncUsageInfo>, "series">;

const dataAccessors = (index: keyof AsyncUsageInfo) => {
    return {
        date: (data?: AsyncUsageInfo) => data?.statusTimestamp,
        xAccessor: (data?: AsyncUsageInfo) => data?.statusTimestamp,
        yAccessor: (data?: AsyncUsageInfo) => {
            return data?.[index] as number | undefined;
        },
    };
};

const charts: SeriesDetails<AsyncUsageInfo>[] = [
    // {
    //     dataKey: "Available IO",
    //     accessors: dataAccessors("availableIO"),
    // },
    // {
    //     dataKey: "Available Worker",
    //     accessors: dataAccessors("availableWorker"),
    // },
    {
        dataKey: "IO in Use",
        accessors: dataAccessors("ioInUse"),
    },
    {
        dataKey: "Worker In Use",
        accessors: dataAccessors("workersInUse"),
    },
    {
        dataKey: "Pending Tasks",
        accessors: dataAccessors("pendingTasks"),
    },
    {
        dataKey: "Threads",
        accessors: dataAccessors("totalThreads"),
    }
];

export const AsyncMetricsChart: React.FC<AsyncMetricsChartProps> = (props) => {
    var chartProps = {
        options: {
            plugins: {
                tooltip: {
                    callbacks: {
                        afterBody: function (tooltipItems: TooltipItem<"line">[]) {
                            const dataPt = props.data?.find(x => x.statusTimestamp ? new Date(x.statusTimestamp).getTime() === tooltipItems[0]?.parsed.x : false);
                            return [`Available workers: ${dataPt?.availableWorker ?? 0}`, `Available IO: ${dataPt?.availableIO ?? 0}`]
                        }
                    },
                },
            },
        },
    } as Partial<ChartProps<"line">>;
    const mergeProps = deepMerge(chartProps, props.chartjsOverrides as any) as any;
    return <HardwareStatusChart {...props} series={charts} yUnit="" chartjsOverrides={mergeProps} />;   
};
